import { cn } from "@/utils/cn";
import { Brain, ChevronDown } from "lucide-react";
import { AnimatePresence, motion } from "motion/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Streamdown } from "streamdown";

export const ThinkingBlock = ({
  text,
  isActive,
}: {
  text: string;
  isActive: boolean;
}) => {
  const { t } = useTranslation();
  const [userToggled, setUserToggled] = useState<boolean | null>(null);
  const isOpen = userToggled ?? isActive;

  if (!text) {
    return null;
  }

  return (
    <div className="flex flex-col min-w-0 mb-2">
      <button
        type="button"
        onClick={() => setUserToggled(!isOpen)}
        className="flex items-center gap-2 py-1 w-fit cursor-pointer text-muted-foreground hover:text-foreground transition-colors"
      >
        <Brain
          size={14}
          className={cn("shrink-0", isActive && "text-primary animate-pulse")}
        />
        <span
          className={cn(
            "text-xs font-medium",
            isActive &&
              "bg-[linear-gradient(90deg,var(--muted-foreground)_0%,var(--foreground)_50%,var(--muted-foreground)_100%)] bg-[length:200%_100%] bg-clip-text text-transparent animate-shimmer",
          )}
        >
          {isActive
            ? t("playground.thinking")
            : t("playground.thoughtProcess")}
        </span>
        <motion.span
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.2 }}
          className="flex items-center"
        >
          <ChevronDown size={13} />
        </motion.span>
      </button>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="overflow-hidden"
          >
            <div className="ms-1.5 ps-4 border-s border-border max-h-56 overflow-y-auto">
              <Streamdown className="text-xs text-muted-foreground leading-relaxed py-1 [&_p]:text-xs [&_li]:text-xs [&_td]:text-xs [&_th]:text-xs [&_h1]:text-sm [&_h2]:text-sm [&_h3]:text-xs [&_h4]:text-xs">
                {text}
              </Streamdown>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
